import React from 'react';
import { Spread } from '../../types/spread';
import CheckIcon from '../../assets/icons/CheckIcon';
import ClockBadgeIcon from '../../assets/icons/ClockBadgeIcon';
import TruckFastIcon from '../../assets/icons/TruckFastIcon';
import ShoppingBagIcon from '../../assets/icons/ShoppingBagIcon';

interface SpreadCardProps {
  spread: Spread;
  columnClassName: string;
}

const SpreadCard: React.FC<SpreadCardProps> = ({ spread, columnClassName }) => (
  <div className={`${columnClassName} d-flex`}>
    <div
      className={`card shadow-sm text-start w-100 ${
        spread.highlight ? 'border-primary border-2' : ''
      }`}
    >
      <div className="card-body text-center d-flex flex-column flex-grow-0 justify-content-between align-items-center p-4 spread-card-body">
        {spread.highlight && (
          <span className="badge rounded-pill bg-primary position-absolute top-0 start-50 translate-middle text-uppercase">
            {spread.highlight}
          </span>
        )}
        <h6
          className={`text-uppercase ${
            spread.highlight ? 'fs-4' : 'fs-5'
          } fw-bold text-primary my-2 card-subtitle`}
        >
          {spread.title}
        </h6>
        <h4
          className="display-6 fw-normal text-primary card-title"
          style={spread.highlight ? { fontWeight: 900 } : { fontWeight: 400 }}
        >
          <strong>
            <span
              style={{
                color: 'rgba(var(--bs-primary-rgb),var(--bs-text-opacity))',
              }}
            >
              {spread.price} EUR
            </span>
          </strong>
        </h4>
      </div>
      <div className="card-footer h-100 d-flex flex-column p-4">
        <ul className="list-unstyled">
          {spread.features.map((feature, i) => (
            <li className="d-flex mb-2" key={i}>
              <CheckIcon />
              <span>{feature}</span>
            </li>
          ))}
        </ul>
        <div className="mt-auto mb-1">
          <ClockBadgeIcon />
          <span>
            Срок за получаване:&nbsp;
            <span className="fw-bold">{spread.receiveByDays ?? '3 дни'}</span>
          </span>
        </div>
        {spread.isExpressEligible && (
          <div className="mt-0 mb-2">
            <TruckFastIcon />
            <span>
              Експресна поръчка до&nbsp;
              <span className="fw-bold">24 часа</span>
            </span>
          </div>
        )}
        <a
          className="btn btn-primary d-flex w-100 justify-content-center align-items-center fw-bold"
          role="button"
          href={spread.button.href}
          style={{ marginTop: 8 }}
        >
          <ShoppingBagIcon />
          {spread.button.text}
        </a>
      </div>
    </div>
  </div>
);

export default SpreadCard;
